

export class FullComment {

    indInDB: number;
    isComment: boolean;
    comments?: string;


}


export class CommentIn{

    indInDB:number;
    isComment:boolean;
}


